import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import LocalizationForm from '../LocalizationForm/LocalizationForm';
import { useModals } from 'hooks/useModals';
import { TLocalizationEdit } from './LocalizationEdit.types';
import { useAppDispatch } from 'store/store';
import { STATIC_LOCALIZATION_FORM_DEFAULT_VALUES } from '../LocalizationForm/constants';
import { TLocalizationFormValues } from '../LocalizationForm/LocalizationForm.types';

const LocalizationEdit: TLocalizationEdit = ({ item }) => {
  const dispatch = useAppDispatch();
  const modals = useModals();

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: { ...STATIC_LOCALIZATION_FORM_DEFAULT_VALUES, ...item },
  });

  const handleSubmit = (data: TLocalizationFormValues) => {
    // dispatch(
    //   updateLocalizationAsyncThunk({
    //     id: item.id,
    //     body: { ...data, id: item.id },
    //     onSuccess: () => {
    //       modals.closeModal();
    //       dispatch(getLocalizationListAsyncThunk());
    //     },
    //   })
    // );
  };

  return (
    <FormProvider {...form}>
      <LocalizationForm onSubmit={handleSubmit} />
    </FormProvider>
  );
};

export default LocalizationEdit;
